import { lazy } from 'react';

const TransformerPageFacturedConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/transformer/factured',
			component: lazy(() => import('./TransformerContainerFactured'))
		}
	]
};

export default TransformerPageFacturedConfig;	